import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, catchError, of, throwError, map } from 'rxjs';
import { environment } from 'src/environments/environment';
import { TokenService } from './token.service';
import { Router } from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class ProfileService {

  constructor(private http: HttpClient, private tokenService: TokenService, private router: Router) { }

  private profileURL = `${environment.baseUrl}/profile/me`;


 getProfile(): Observable<any> {
    return this.http.get(this.profileURL, { observe: 'response' })
      .pipe(
        catchError((error: any) => {
          if (error.status === 401) {
            this.tokenService.removeToken();
            this.router.navigate(['/login']);
          }
          return of(error);
        }),
        map((response: any) => {
          if (response.status !== 200) {
            this.tokenService.removeToken();
            this.router.navigate(['/login']);
            return throwError('No autorizado');
          }
          return response.body;
        })
      );
  }

}
